import { Button as MuiButton } from '@mui/material';
import { CloudUpload as CloudUploadIcon } from '@mui/icons-material';
import { ClickGridCellFileUploadFunction } from './GridCellFileUploadFunction';
import React, { useState } from 'react';

// 파일 업로드 시 다음과 같이 오류가 생겨 공통 컴포넌트로 분리함.
// 오류 :     기존 FileForm 컴포넌트는 각 셀 안에서 input을 사용하는 것이 아닌 셀 바깥에서 단일 input 생성에 중점
//           때문에 각 셀 안에서 input 사용하려면 업로드 버튼 클릭 시 파일 선택 창이 뜨지 않거나 파일 선택 시
//           반영되지 않는 등에 오류가 있음 즉, AG-Grid 셀마다의 고유한 input 흐름을 처리하지 못함
// 해결방안 : 각 셀 안에 개별 input 요소를 동적으로 생성, input.click() 타이밍 문제를 피하기 위해 setTimeout + appendChild/removeChild 방식 사용
// 사용법 :  cellRenderer에 사용
//          <GridCellFileUpload
//            label="작업환경측정 서식 업로드" // 버튼 text
//            gridRef={gridRef}            // AG Grid 참조 객체
//            e={e}                        // 셀 클릭 이벤트
//            props={props}                // 데이터 객체
//          />

export default function GridCellFileUpload({
  label = '파일 업로드',
  color = 'secondary',
  extension = '',
  gridState,
  gridRef,
  e,
  props,
  blockPpt = false,
  blockExcel = false,
  blockDocx = false,
}) {
  const [isUploading, setIsUploading] = useState(false);

  const handleClick = (event) => {
    ClickGridCellFileUploadFunction(
      event,
      gridState,
      gridRef,
      e,
      extension,
      props,
      isUploading,
      setIsUploading,
      { blockPpt, blockExcel, blockDocx }
    );
  };

  return (
    <MuiButton
      variant="contained"
      component="label"
      startIcon={<CloudUploadIcon />}
      color={color}
      sx={{ whiteSpace: 'nowrap' }}
      onClick={handleClick}
    >
      {label}
    </MuiButton>
  );
}
